(function () {
  var STORAGE_KEY = 'wp_seen_v1';

  document.querySelectorAll('[data-welcome-popup]').forEach(function (popup) {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    var alreadySucceeded = popup.querySelector('.welcome-popup__success');

    var delay = 6000;
    var delayAttr = popup.getAttribute('data-delay');
    if (delayAttr) delay = parseInt(delayAttr, 10) * 1000;

    function show() {
      popup.classList.add('show');
      sessionStorage.setItem(STORAGE_KEY, '1');
    }

    function hide() {
      popup.classList.remove('show');
    }

    popup.querySelectorAll('[data-welcome-popup-close]').forEach(function (el) {
      el.addEventListener('click', hide);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });

    if (alreadySucceeded) {
      show();
    } else {
      setTimeout(show, delay);
    }

    var codeEl = popup.querySelector('[data-welcome-copy-code]');
    var hintEl = popup.querySelector('[data-welcome-copy-hint]');
    if (codeEl) {
      codeEl.addEventListener('click', function () {
        var text = codeEl.textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(function () {
            if (hintEl) {
              var original = hintEl.textContent;
              hintEl.textContent = 'Copied!';
              setTimeout(function () {
                hintEl.textContent = original;
              }, 1500);
            }
          });
        }
      });
    }
  });
})();
